import { useDrawer } from 'src/hooks/useDrawer';
import { NavLink } from 'react-router';
import { useRoute } from 'src/router/hooks';

import { LogoMobile } from 'src/config/components/LogoMobile';
import { HeaderLogo } from 'src/config/components/HeaderLogo';

export const Logo = () => {
  const { closeDrawer } = useDrawer();
  const { ROUTE } = useRoute();
  return (
    <NavLink
      to={ROUTE.MAIN.get()}
      style={{ cursor: 'pointer' }}
      aria-label={'main page'}
      onClick={closeDrawer}>
      <HeaderLogo />
      <LogoMobile className="block lg:hidden max-h-[35px] max-w-[52px] h-full r_sm:h-[35px] object-contain ml-2.5" />
    </NavLink>
  );
};
